import "prismjs";
import "prismjs/themes/prism-tomorrow.css";
// import "prismjs/components/prism-json.js";
import "../main.js";

export default {};
